import {Component, Input, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgEvent} from '../../../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../../../misc/classes/ExgApplicationEventEmitter';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-sv-user-scoring',
  templateUrl: './sv-user-scoring.component.html',
  styles: []
})
export class SvUserScoringComponent extends ExcTranslation implements IExgEvent {

  @ViewChild('VCQuestTable', {read: ExgDataListComponent}) VCQuestTable!: ExgDataListComponent;

  // @ViewChild('VCQuestTableFilterControl', {read: ExgFilterComponent}) VCQuestTableFilterControl!: ExgFilterComponent;
  [key: string]: any;

  private _data: any;

  @Input()
  set data(value: any) {
    this._data = value;
    this.config.questTable.loadData();
  }

  get data(): any {
    return this._data;
  }

  AvailableDateList: any[] | undefined;
  Events: ExgApplicationEventEmitter = new ExgApplicationEventEmitter();

  // data
  questTable = {
    data: [] as any,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true
  };
  // config
  config = {
    questTable: {
      selectKey: 'bmqID',
      state: 1,
      selectedRow: undefined as any,
      searchValue: '',
      uiFilter: [] as any[],
      uiSort: [] as any[],
      ready: () => {
        if (!this.questTable.data || this.questTable.data.length === 0) {
          this.config.questTable.state = 2;
          this.VCQuestTable.selectedRow = -1;
        } else {
          this.config.questTable.state = 0;
          this.VCQuestTable.selectedRow = 0;
        }
      },
      selectionChanged: (index: number) => {
        this.config.questTable.selectedRow = this.questTable.data[index];
      },
      pageChanged: (page: number) => {
        if (this.questTable.MetaInfo.dataPaging !== undefined) {
          this.questTable.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.questTable.loadData();
      },
      search: (value: string) => {
        this.config.questTable.searchValue = value;
        this.config.questTable.pageChanged(1);
      },
      loadData: () => {
        const SELF = this;
        SELF.config.questTable.state = 1;
        SELF.questTable.isLoading = true;
        SELF.excRest
          .sget(
            SELF.excRest.computeUrl('OER_Benutzer_BonusMalusQuestionareR_List', {
              oeID: this._data.oeID,
              fts: this.config?.questTable?.searchValue,
            }),
            'questTable',
            {MetaInfo: SELF.questTable.MetaInfo}
          )
          .subscribe((response: any) => {
            if (response.success && response.data) {
              SELF.questTable.data = response.data.BonusMalusQuestionareList;
              SELF.questTable.paging = response.paging.BonusMalusQuestionareList;
              SELF.AvailableDateList = response.data.AvailableDateList;
            } else {
              SELF.questTable.data = [];
              SELF.questTable.paging = {
                pagingPage: 0,
                pagingEndRow: 0,
                pagingPageSize: 25,
                pagingTotalPages: 0,
                pagingTotalRows: 0,
                pagingStartRow: 0,
              };
              SELF.AvailableDateList = [];
            }
            SELF.config.questTable.ready();
            SELF.questTable.isLoading = false;
          });
      }
    }
  };

  constructor(
    public excRest: ExcRestService,
    public modalSrv: ExgModalService,
    public excSecurity: ExcSecurityService) {
    super();
  }

  add(): void {
    if (this.AvailableDateList?.length === 0) {
      return;
    } else {
      this.modalSrv.show('ModalUserScoringEditComponent',
        {bmq_oeID: this._data.oeID, oeName: this._data.oeName + ',' + this._data.oeEName, AvailableDateList: this.AvailableDateList}
      ).subscribe((ret: any) => {
        if (ret && ret.success) {
          this.excRest.post(
            this.excRest.computeUrl('BonusMalusQuestionareC'), ret.data).subscribe((response: any) => {
            this.config.questTable.loadData();
          });
        }
      });
    }
  }


  edit(row: any): void {
    row.oeName = this._data.oeName + ',' + this._data.oeEName;
    this.modalSrv.show('ModalUserScoringEditComponent', row).subscribe((ret: any) => {
      if (ret && ret.success) {
        this.excRest.put(
          this.excRest.computeUrl('BonusMalusQuestionareU', {bmqID: row.bmqID}), ret.data
        ).subscribe((response: any) => {
          this.config.questTable.loadData();
        });
      }
    });
  }

  unlock(row: any) {
    this.modalSrv.showSimple('Bewertung entsperren',
      'Sind Sie sicher, dass Sie die Bewertung ' + row.bmqMonth + '/' + row.bmqYear + ' entsperren möchten?',
      true, true, 'Entsperren', 'Abbrechen').subscribe(e => {
      if (e) {
        this.excRest.put(
          this.excRest.computeUrl('BonusMalusQuestionareU', {bmqID: row.bmqID}), Object.assign(row, {Unlock: true})).subscribe((response: any) => {
            this.config.questTable.loadData();
          }
        );
      }
    });
  }
}
